<template>
  <div class="approval-review-info">
    <div class="approval-review-info__overview">
      <h4 class="approval-review-info__overview--title">Order Overview</h4>
    </div>
    <div
      class="approval-review-info__line-item line-item"
      v-if="lineItem"
    >
      <h3 class="line-item__title">{{ product.title }}</h3>

      <hr class="line-item__split-line" />

      <p class="line-item__option" v-if="product.type">
        <span class="line-item__option-key">Type:</span>
        <span class="line-item__option-value">{{ product.type }}</span>
      </p>

      <p class="line-item__option" v-if="lineItem.quantity">
        <span class="line-item__option-key">Quantity:</span>
        <span class="line-item__option-value">{{ lineItem.quantity }}</span>
      </p>

      <hr v-if="pricing" class="line-item__split-line" />

      <p class="line-item__option line-item__option-total" v-if="pricing">
        <span class="line-item__option-key">Total price:</span>
        <span class="line-item__option-key">
          {{ pricing.totalPrice }}
        </span>
      </p>

      <hr class="line-item__split-line" />
    </div>
    <div class="approval-review-info__checkout">
      <slot name="checkout"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import pinia from '../../core/pinia';
import { useConfigStore, useLineItemStore } from '../../stores';
import PriceCalculatorService from '../../services/price-calculator.service';

const configStore = useConfigStore(pinia);
const lineItemStore = useLineItemStore(pinia);

const product = computed(() => configStore.getProduct);
const lineItem = computed(() => lineItemStore.getLineItem);
const currency = computed(() => configStore.getCurrency);
const pricing = computed(() => {
  const breakPoints = configStore.getBrakePoints;
  if (!breakPoints) return 0;
  const quantity = (lineItem.value) ? lineItem.value.quantity : 0;
  const priceCalculator = new PriceCalculatorService(quantity);
  const breakPoint = priceCalculator.getMinBreakPoint(breakPoints) || undefined;
  const calculatorResult = priceCalculator.calculate({ breakPoint });
  if (currency.value && calculatorResult) {
    const USDollar = new Intl.NumberFormat('en-US');
    return {
      totalPrice: currency.value + USDollar.format(calculatorResult.totalPrice),
      pricePerEach: currency.value + USDollar.format(calculatorResult.pricePerEach),
    };
  } else {
    return null;
  } 
});
</script>

<style scoped lang="scss">
.approval-review-info {
  width: 100%;
  font-family: 'Montserrat', sans-serif;
  line-height: 24px;
  letter-spacing: 0%;
  vertical-align: middle;
  
  &__overview {
    display: flex;

    &--title {
      font-weight: 500;
      font-size: 16px;
      padding: 0;
      margin: 0;
    }
  }

  &__line-item {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px 0;
  }

  &__checkout {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}

.line-item {
  &__split-line {
    border: none;
    border-bottom: 1px solid;
    border-color: #D7D9DB;
    color: #D7D9DB;
    width: 100%;
    margin: 0;
  }

  &__title {
    font-weight: 400;
    font-size: 24px;
    padding: 0;
    margin: 0;
  }

  &__option {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0;
    margin: 0;
    font-size: 14px;
  }

  &__option-total {
    justify-content: space-between;
  }

  &__option-key {
    font-weight: 600;
  }

  &__option-value {
    font-weight: 400;
  }
}
</style>